module.exports = __webpack_public_path__ + "/img/57ee71ee2d9007e5d109ccc9e681082f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/client/assets/appimg/ewelcome-005.png
 ** module id = 26
 ** module chunks = 0 4 5
 **/